export default "__VITE_ASSET__Mk8a0fTu__"